import React from 'react';
import moment from 'moment';

const t = {
  today: 'Today',
  tomorrow: 'Tomorrow',
  time_add_day: '(+1 day)',
};

const getDateLabel = (date) => {
  const isToday = moment(date).isSame(moment(), 'day');
  const isTomorrow = moment(date).isSame(moment().add(1, 'day'), 'day');

  if (isToday) {
    return t.today;
  }

  if (isTomorrow) {
    return t.tomorrow;
  }

  return moment(date).format('Do MMM');
};

const getAddDayLabel = (date1, date2) =>
  moment(date1).isSame(moment(date2), 'day') ? '' : t.time_add_day;

const TimeDetailRow = ({ timeFrom, timeTo, label, showDate = true }) => (
  <div className="times-row__time-container">
    <div className="times-row__date">{showDate && getDateLabel(timeFrom)}</div>
    <div className="times-row__time">
      {`${moment(timeFrom).format('HH:mm')} - ${moment(timeTo).format('HH:mm')} ${getAddDayLabel(
        timeFrom,
        timeTo
      )}`}
    </div>
    {!!label && <div className="times-row__label"> - {label}</div>}
  </div>
);

export default TimeDetailRow;
